/**
 * Словарь языков продукта — ЛИСТОВОЙ модуль: ни одного value-импорта.
 *
 * Жил в `schemas/project-settings.ts`, и оттуда его нельзя было взять
 * значением из `@aica/api-types`: баррель `@aica/core/schemas` сам
 * value-импортирует из `@aica/api-types` (`prompt-builder.ts`,
 * `analysis-client-config.ts`), и импорт замыкал цикл — при вычислении модуля
 * api-types константа была `undefined`, `z.enum` падал на загрузке вместе со
 * всеми потребителями пакета (#861, PR 2). Лист в цикле участвовать не может, а
 * `schemas/project-settings.ts` реэкспортирует отсюда, так что прежние импорты
 * не меняются. Вход — `@aica/core/languages`.
 */
import type { Language } from './i18n/types';

/**
 * Локали, на которые переведены НАШИ шаблонные строки: отчёт в CRM, блок
 * акустики в промпте, системная причина attention в письме об алерте.
 *
 * SSOT для двух списков, которые обязаны совпадать: выбор языка отчёта
 * (`analysisLanguage` в `schemas/project-settings.ts`) и резолв
 * `templateLanguage` в пайплайне (apps/workflows-api/.../steps/project-config.ts).
 * Пятый язык, добавленный только в один из них, дал бы отчёт в CRM на одном
 * языке, а прозу анализа — на другом; здесь второй список выводится из
 * первого, поэтому разойтись им нечем.
 */
export const TEMPLATE_LANGUAGES = [
  'en',
  'ru',
  'uk',
  'es',
] as const satisfies readonly Language[];

/**
 * Допустимые значения языка отчёта: наши локали плюс 'auto' («на языке
 * разговора»). Всё, что вне этого набора, покрывает именно 'auto'.
 */
export const ANALYSIS_LANGUAGES = ['auto', ...TEMPLATE_LANGUAGES] as const;

export type TemplateLanguage = (typeof TEMPLATE_LANGUAGES)[number];
export type AnalysisLanguage = (typeof ANALYSIS_LANGUAGES)[number];
